<template>
  <div class="goods" :style="{ bottom: mybottom, top: goodsStyle}">
      <!-- 分类列表 -->
      <!-- 商品列表 -->
<div class="foods-wrapper" ref="foodScroll">
  <div>
  <ul>
    <!--具体分类 -->
    <li class="food-list food-list-hook">
    <!-- <h3 class="title">{{item.name}}</h3> -->
    <!-- 具体的商品列表 -->
      <ul class="goods-box">
          <li v-for="(goods,index) in data" :key="index"  class="food-item"  v-if="goods.price != 0">
              <template v-if="goods.goods_id != 0">
                  <div class="icon" v-lazy-container="{cselector: 'img'}">
                    <!-- <img :src="goods.freight_image" class="icon" @click="showDetail(goods)"> -->
                    <img :data-src="goods.img" class="icon">
                  </div>
                  <div class="content">
                    <span class="saled">{{ goods.freight_name | ellipsis }}</span><br/>
                    <!-- <p class="desc" v-if="goods.goods.goodsContent">{{goods.goods.goodsContent}}</p> -->
                    <div class="extra">
                      <span class="saled">货道：{{ goods.No }}</span><br/>
                      <span class="praise">剩余：{{ goods.stock }}</span>
                    </div>
                    <!-- <img class="product" :src="food.product_label_picture"> -->
                    <p class="price">
                       <span class="text">￥{{ goods.price }}</span>
                       <span class="unit">/{{ goods.freight_unit }}</span>
                    </p>
                  </div>
              </template>             
              <template v-if="goods.goods_id === 0">
                  <div class="icon">
                    <div class="freightWayShow">{{ goods.No }}</div>
                  </div>
                  <div class="content">
                    <span class="saled">{{ goods.freight_name != '' ? goods.freight_name : '***' | ellipsis }}</span> 
                    <div class="extra">
                      <span class="saled">货道：{{ goods.No }}</span><br/>
                      <span class="praise">剩余：{{ goods.stock }}</span>
                    </div>
                    <!-- <img class="product" :src="food.product_label_picture"> -->
                    <p class="price">
                       <span class="text">￥{{ goods.price }}</span>
                       <span class="unit"></span>
                    </p>
                  </div>
              </template>
              <div class="cartcontrol-wrapper">
                  <app-cart-control v-if="cartType == 1" :cartNum="cartNum" :imei="imei" :food="goods" :selectCount="selectCount" :c_num="c_num"  :lock="lock" :lock_times="lock_times" v-show="goods.price!=0"  @showTips="showTips"></app-cart-control>
                  <button 
                  :g="goods" 
                  v-if="goods.price!=0 && cartType == 0"
                  @click="toPay(goods)" 
                  class="button"
                  >购买
                </button>
              </div>
          </li>
        </ul>
    </li>
  </ul>
  </div>
</div>
<!-- 购物车-->
<app-shocart v-if="cartType == 1" :cartNum="cartNum" :imei="imei" :poinfo="poinfo" :selectFoods="selectFoods" :selectCount="selectCount" :c_num="c_num" :lock="lock" :lock_times="lock_times" @clearSelectCount = "clearSelectCount"  @selectGoods = "selectGoods" @showTips="showTips" @showMessages="showMessages"></app-shocart>
<!-- 商品详情 -->
<app-product-detail v-if="cartType == 1" :cartNum="cartNum" :imei="imei" :food="selectFood"  :c_num="c_num" :lock="lock" :lock_times="lock_times" :selectCount="selectCount" ref="foodView" @showTips="showTips"></app-product-detail>
</div>
</template>

<script>
import ProductDetail from '../../components/productDetail/ProductDetail'
import BScroll from 'better-scroll'
import Shopcart from'../shopcart/Shopcart'
import Cartcontrol from '../cartcontrol/Cartcontrol'
export default {
  name: 'Header',
  props:['imei','cartType','cartNum','bsoll','c_num','lock','lock_times','head'],
  
  data () {
    return {
      goodsStyle: '70px',
      container:{},
      goods:[],
      data:[],
      listHeight:[],
      menuScroll:{},
      foodScroll:{},
      scrollY:0,
      mybottom:'0px',
      poinfo:{
            "name": "",
            "shipping_time": "00:00-04:45,05:00-10:15,10:30-23:59",
            "wm_poi_score":4.7,
            "discounts2": [
              {
                "info": "为避免商品堵塞取货口，建议单次购物不要超过5个。",
                "icon_url": ""
              }
            ],
            "shipping_fee_tip": "",
            "min_price_tip": "",
            "delivery_time_tip": "",
            "poi_back_pic_url": "",
            "pic_url": "",
            "head_pic_url": "",
       },
       selectFood:{
          No:1,
          goods_id:1,
          goods:{
            goods_id:"",
            freight_image:"",
            freight_name:"",
            freight_unit:"",
            freight_countent:""
          },
          price:"0.00",
          state:1,
          stock:5,
          machine_id:"",
          merchantId:""
       },
       selectCount:1,
    }
 },
 computed: {
   selectFoods(){
      //console.log("selectFoods")
      let num =0;
      let foods = [];
      this.data.forEach((food) => {
          if(food.count > 0){
            //限制货道
            //num = num +1;
            //限制商品数量
            num =+ num + food.count;
            this.selectCount = num + 1;
            //console.log(num)
            if(num <= this.cartNum){
                foods.push(food);
            }
          }
      })
      return foods;
    },
   currentIndex(){
     for(let i=0;i<this.listHeight.length;i++){
      //范围
      let height1=this.listHeight[i]
      let height2=this.listHeight[i+1]
      //是否在上述区间
      if((!height2 || (this.scrollY>=height1&&this.scrollY<height2))){
          return i
      }
     }
      return 0
   }
 },
  created() {
   this.getdata();
   // console.log(this.lock)
   // console.log(this.lock_times)
   if(this.head){
      this.goodsStyle = "240px"
    }else{
      this.goodsStyle = "70px"
    }
  },
  components:{
    "app-shocart":Shopcart,
     "app-cart-control":Cartcontrol,
     "app-product-detail":ProductDetail
  },
  filters: {
    //当商品名称超出时超出部分显示...
    ellipsis(value){
      if(!value) return ''
      if(value.length > 50){
        return value.slice(0,50) + '...'
      }
      return value
    }
  },
  methods: {
    clearSelectCount:function(){
      // console.log("清空购物车，重新获取货道数据")
      this.selectCount = 0;
      this.getdata()
    },
    selectGoods:function(that){
      // console.log("selectGoods")
      this.$emit('selectGoods',that)
    },
    initScroll(){
      // console.log('执行滚动方法');
      this.foodScroll = new BScroll(this.$refs.foodScroll,{
        probeType:3,
        click:true
      })
      // foodScroll 监听事件
      this.foodScroll.on("scroll",(pos) => {
        // console.log(pos.y)
        this.scrollY = Math.abs(Math.round(pos.y))
        //console.log(this.scrollY)
      })

    },
    head_bg(imgname){
      //查找替换回车
      // console.log(imgname)
      //imgname = imgname.replace(/('\')/g,'/');
      return "background-image: " + imgname + ";"

    },
    getdata(t=1,p=1){
      // console.log("获取货道数据")
      this.data = []
      if(this.lock == 1){
        var url ="https://home.hrcc7.com/server/c/getFreight?imei="+this.imei
        //var url ="http://192.168.1.246/home/api/c/getFreight?machine_id="+this.machineId+"&page="+p
      }
      if(this.lock == 0){
        var url = "https://home.hrcc7.com/server/c/goods/?imei="+this.imei
        //var url = "http://192.168.1.246/home/api/c/goods/?machineId="+this.machineId+"&page="+p
      }
      this.axios.get(url)
      .then(response =>{
        //console.log(response)
        if(response.data.code == 2000){
          this.data =response.data.data.goods
          //console.log(this.data)
          var iOSVersion = this.getiOSVersion();
          console.log(iOSVersion)
          if(iOSVersion !== null && parseInt(iOSVersion) < 14){
            //循环处理商品图片
            for(let i=0; i<response.data.data.goods.length ; i++){
              if(response.data.data.goods[i].img.length > 0){
                this.data[i].img = response.data.data.goods[i].img.slice(0,(response.data.data.goods[i].img.length - 5))
              }
            }
            console.log(this.data)
          }
          if(this.data.length == 0){
            //弹出提示  告知无可用货道
            this.showTips("该售货机无可买商品！");
          }
          if(t==1){
              console.log('调用滚动方法')
              this.$nextTick(() => {
                // 执行滚动方法
                this.initScroll();
              })
          }    
        }else{
            //alert("获取数据出现错误，请您尝试重新扫码")
            this.showTips("获取数据出现错误，请您尝试重新扫码");
            setTimeout(function(){
              window.opener=null;
              window.close();
            },3000)
            return;
        }
      })
      .catch(res=>{
        //console.log(res)
      })
    },
    calculateCount(spus){
      let count=0;
      spus.forEach((food)=>{
        if(food.count>0){
           count+=food.count
        }
      })
      return count
    },
    showDetail(item){
      if(this.cartType == 1){
        this.selectFood=item
        this.$refs.foodView.showView()
      }
    },
    showTips(info){
      //提示消息
      this.$emit('showTip',info)
    },
    showMessages(info){
      //提示消息
      this.$emit('showMessage',info)
    },
    toPay(that){
      if(this.lock == '1'){
        // console.log(that)
        this.postInfo= { "imei":this.imei, "No":that.No, "c_num":this.c_num }
        // console.log(this.postInfo)
        const url = "https://home.hrcc7.com/server/c/add_goods"
        this.axios.post(   //请求方式
        url,  //添加商品接口地址
        this.postInfo  //传递参数 
        )    
        .then(response =>{
            if(response.data.code === 2000){
                //向父组件传值
                this.$emit('chooseGoods',that)
            }else{
                //提示消息
                this.$emit('showTip',response.data.msg)
            }
        })
      }else{
          //向父组件传值
          this.$emit('chooseGoods',that)
      }
      
    },
    getiOSVersion() {
      var userAgent = navigator.userAgent;
      var match = userAgent.match(/(iPhone|iPad|iPod).*?OS\s([\d_]+)/);
      if (match && match[2]) {
        return match[2].replace(/_/g, '.');
      }
      return null;
		}
  },
  watch: {
    cartType:{
      handler: function (val, oldVal) { 
      /* ... */
        if(this.cartType == 1){
          this.mybottom = "50px"
        }else{
          this.mybottom = "0px"
        }
      },
      deep: true
    },
    head:{
      handler: function (val, oldVal) { 
      /* ... */
        if(this.head){
          this.goodsStyle = "240px"
        }else{
          this.goodsStyle = "70px"
        }
      },
      deep: true
    }
    // bsoll:{
    //   handler(newName, oldName) {
    //     if(this.bsoll){
    //       this.initScroll();
    //     }
    //   },
    //   immediate: true
    // }
  }
}
</script>
}

<style scoped>

ul{
  padding: 0!important;
  list-style: none;
}
.goods{
  display: flex;
  position: absolute;
  /*bottom: 50px;*/
  overflow: hidden;
  /* background-color: red; */
  width: 100%;
  left: -5px;
}
.goods .menu-wrapper{
   flex:0 0 85px;
   background-color: #f4f4f4;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center
   /* display: flex; */
}
.goods .foods-wrapper{
    flex-grow: 1;
    /* background-color: blue; */
}
.goods .menu-wrapper .menu-item{
  /* border-bottom: 1.1px solid #e4e4e4 */
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center; 
  border-bottom: 1.1px solid #e4e4e4;
  position: relative;
}

.goods .menu-wrapper .menu-item .text{
	font-size: 30px;
	color: #333333;
	line-height: 17px;
	/* justify-content: middle; */
    /* display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden; */
    padding-bottom: 4px;
}
.goods .menu-wrapper .menu-item .text .icon{
	width: 30px;
	height: 30px;
  margin: auto;
	/* justify-content: middle; */
}


/* 专场样式 */
 .goods .foods-wrapper .container-list{
	padding: 0px 11px 0 11px;
	border-bottom: 1px solid #E4E4E4;
}

.goods .foods-wrapper .container-list img{
	width: 100%;
	margin: auto;
	border-radius: 5px;
}
/* 具体分类商品布局 */ 
.goods .foods-wrapper .food-list{
	padding-left: 8px;
}



.goods .foods-wrapper .food-list .title{
	height: 13px;
	font-size: 12px;
	background: url(./img/btn_yellow_highlighted@2x.png) no-repeat left center;
	background-size: 2px 10px;
	padding-left: 7px;
	margin-bottom: 12px;
}
.goods .foods-wrapper .food-list .goods-box{

	display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-basis: auto;
  align-content:flex-start;
}




@media only screen and (max-width: 320px) {
    .goods .foods-wrapper .food-list .food-item{
      display: flex;
      margin-left:5px;
      margin-bottom: 5px;
      position: relative;
      width:44%;
      padding-top:10px;
      padding-bottom: 15px;
      border: 1px solid #C0C0C0;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    .goods .foods-wrapper .food-list .food-item  .icon{
      flex: 0 0 60px;
      background-position: center;
      background-size: 120% 100%;
      background-repeat: no-repeat;
      margin: auto;
      height: 60px;
    }
    .button-class{
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .button{
      background-color: orange;
      width: 60px;
      color: #fff;
      border: none;
      box-shadow: -1px -2px -2px 0 #615959;
      border-radius: 3px;
      font-size: 14px;
      margin-right:10px;
      margin-bottom:5px;
    }
}
@media only screen and (min-width: 320px) {
  .goods .foods-wrapper .food-list .food-item{
      display: flex;
      margin-left:5px;
      margin-bottom: 5px;
      padding-left:5px;
      position: relative;
      width:46%;
      padding-top:10px;
      padding-bottom: 15px;
      border: 1px solid #C0C0C0;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .goods .foods-wrapper .food-list .food-item  .icon{
      flex: 0 0 70px;
      background-position: center;
      background-size: 120% 100%;
      background-repeat: no-repeat;
      margin: auto;
      height: 70px;
    }
    .button-class{
      position: absolute;
      right: 0;
      bottom: 0;
    }

    .button{
      background-color: orange;
      width: 80px;
      color: #fff;
      border: none;
      box-shadow: -1px -2px -2px 0 #615959;
      border-radius: 3px;
      font-size: 14px;
      margin-right:10px;
      margin-bottom:5px;
    }
}

.goods .foods-wrapper .food-list .food-item .freight{
  flex: 0 0 100px;
  background-position: center;
  background-size: 120% 100%;
  background-repeat: no-repeat;
  margin-top: 20px;
  margin-right: 11px;
  height: 100px;
}
.freightWayShow{
  text-align: center;
  width:80px;
  height: 80px;
  line-height: 80px;

  font-size: 40px;
  color: #000;
}
.goods .foods-wrapper .food-list .food-item .content{
	flex: 1;
  padding-left: 5px;
}
/* 具体内容样式 */ 
.goods .foods-wrapper .food-list .food-item .content .name{
	font-size: 12px;
	line-height: 21px;
	color: #333333;
	margin-bottom: 10px;
	padding-right: 27px;

}

.goods .foods-wrapper .food-list .food-item .content .desc{
	font-size: 10px;
	color: #bfbfbf;

/* 超出部分显示省略号*/
	-webkit-line-clamp: 1;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	overflow: hidden;
}

.goods .foods-wrapper .food-list .food-item .content .extra{
	font-size: 10px;
	color: #BFBFBF;
	
}
.goods .foods-wrapper .food-list .food-item .content .extra .saled{
	margin-right: 14px;
}
.goods .foods-wrapper .food-list .food-item .content .product{
	height: 15px;
	margin-bottom: 6px;
}
.goods .foods-wrapper .food-list .food-item .content .price{
	font-size: 0;
  padding-bottom: 15px;
}
.goods .foods-wrapper .food-list .food-item .content .price .text{
	font-size: 14px;
	color: #fb4e44;
}
.goods .foods-wrapper .food-list .food-item .content .price .unit{
	font-size: 12px;
	color: #BFBFBF;
}
/* 当前选中 */ 
.goods .menu-wrapper .menu-item.current{
	background: white;
	font-weight: bold;
	margin-top: -1px;
}
.goods .menu-wrapper .menu-item:first-child.current{
	margin-top: 1px;
}

.goods .foods-wrapper .food-list .food-item .cartcontrol-wrapper{
	position: absolute;
	right: 0;
	bottom: 0;
}

.goods .menu-wrapper .menu-item .num{
	position: absolute;
	right:6px;
	top: 6px;
	width: 13px;
	height: 13px;
	border-radius: 50%;
	color: white;
	background: red;
	text-align: center;
	font-size: 7px;
	line-height: 13px;
}

</style>    


// WEBPACK FOOTER //
// src/components/goods/Goods.vue